import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { EditorContextCustomSitesConfigPanelProps } from './ConfigPanel/EditorContextCustomSitesConfigPanel.tsx';

export const LazyEditorContextCustomSitesConfigPanel: LoadableType<EditorContextCustomSitesConfigPanelProps> =
	LoadableLazy({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-EditorContextCustomSitesConfigPanel" */ './ConfigPanel/EditorContextCustomSitesConfigPanel.tsx'
				)
			).EditorContextCustomSitesConfigPanel,
	});
